<template>
  <div class="w-100">
    <textarea id="new_message" v-model="newMessage" data-test="new_message" class="form-control border-0" rows="2" placeholder="Type a message" style="resize: none; box-shadow: none;"></textarea>
    <button id="send_message" data-test="send_message" :disabled="newMessage.length === 0" class="btn btn-sm btn-primary mt-2 float-end" type="button" @click="sendMessage">
      <span>Send</span>&nbsp;
      <i class="fa-solid fa-paper-plane-top"></i>
    </button>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    user_id: {
      type: [String, Number],
      default: null,
    },
    network: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      newMessage: '',
    };
  },
  methods: {
    sendMessage() {
      this.$http
        .post('user-messages', {
          message: this.newMessage,
          recipient_user_id: this.user_id,
          network_id: this.network ? this.network.id : null,
        })
        .then(() => {
          let data = {
            message: this.newMessage,
            recipient_user_id: this.user_id,
            is_sent: true,
            created_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            network: this.network,
          };
          this.$emit('user-message-sent-event', data);
          this.newMessage = '';
        });
    },
  },
};
</script>
